module.exports = __webpack_public_path__ + "fonts/bryant-bold.b0969ebc.ttf";